
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/set-16/tables/call-to-chaos",
      function () {
        return require("private-next-pages/info/set-16/tables/call-to-chaos.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/set-16/tables/call-to-chaos"])
      });
    }
  